import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { globalServices } from "../../Services/global.service";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

const ProductsFilterModal = ({
  show,
  storeId,
  prodList,
  documentOption,
  handleHide,
  confirmAdd,
}) => {
  const { t: translator } = useTranslation();
  const [products, setProducts] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    globalServices
      .getFilterProducts(storeId, Number(documentOption))
      .then((res) => {
        let items = res.data.data.filter(
          (ar) => !prodList.find((rm) => rm.productGuid === ar.productGuid)
        );

        setProducts(items);
      })
      .catch((err) => console.log(err));
  }, [storeId, prodList]);

  const { SearchBar } = Search;

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems((selectedItems) => [...selectedItems, row]);
    } else {
      setSelectedItems((selectedItems) =>
        selectedItems.filter((p) => p.productGuid !== row.productGuid)
      );
    }
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={selectedItems.find(
              (x) => x.productGuid === row.productGuid
            )}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const passSelectedItems = () => {
    confirmAdd(selectedItems);
    onHide();
  };

  const onHide = () => {
    setSelectedItems([]);
    handleHide();
  };

  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "productName",
      text: translator("TenantDetail-ItemTab-TableHeader-Name"),
    },
    {
      dataField: "groupName",
      text: translator("TenantDetail-ItemTab-TableHeader-ItemGroup"),
    },
    {
      dataField: "price",
      formatter: currencyFormatter,
      text: translator("TenantDetail-ItemTab-TableHeader-Price"),
    },
    {
      dataField: "unitMeasureName",
      text: translator("TenantDetail-ItemTab-TableHeader-UnitOfMeasure"),
    },
  ];

  return (
    <Modal size="lg" show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{translator("ProductsFilter-Title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: 400 }}>
        <ToolkitProvider
          keyField="productGuid"
          data={products}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <SearchBar
                {...props.searchProps}
                placeholder={translator("Search")}
              />
              <hr />
              <BootstrapTable
                {...props.baseProps}
                noDataIndication={translator("No-Data")}
                pagination={paginationFactory(options)}
              />
            </div>
          )}
        </ToolkitProvider>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={onHide}
        >
          {translator("Users-DeleteModal-Cancel")}
        </button>
        <button
          disabled={selectedItems.length === 0 ? true : false}
          onClick={passSelectedItems}
          type="button"
          className="btn btn-primary"
        >
          {translator("Confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductsFilterModal;
